/* product-accordion.js
   Custom element that powers the <product-accordion> blocks on product
   detail pages. Toggles aria-expanded on the trigger button when clicked.
   The actual height animation is CSS (grid-template-rows 0fr/1fr trick).
   Only one accordion stays open at a time within the same product.
*/
(function () {
  if (customElements.get('product-accordion')) return;

  class ProductAccordion extends HTMLElement {
    connectedCallback() {
      this._trigger = this.querySelector('.product-accordion__trigger');
      if (!this._trigger) return;

      this._onClick = () => {
        const isOpen = this._trigger.getAttribute('aria-expanded') === 'true';
        const willOpen = !isOpen;

        this._trigger.setAttribute('aria-expanded', String(willOpen));

        // Khulte waqt baqi accordions ko band kar do (ek waqt mein sirf ek)
        if (willOpen) this._closeSiblings();
      };

      this._trigger.addEventListener('click', this._onClick);
    }

    _closeSiblings() {
      const scope = this.closest('product-info') || document;
      scope.querySelectorAll('product-accordion').forEach((acc) => {
        if (acc === this) return;
        const trigger = acc.querySelector('.product-accordion__trigger');
        if (trigger && trigger.getAttribute('aria-expanded') === 'true') {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    disconnectedCallback() {
      if (this._trigger && this._onClick) {
        this._trigger.removeEventListener('click', this._onClick);
      }
    }
  }

  customElements.define('product-accordion', ProductAccordion);
})();